import React, { Component } from 'react'
import { AssessTestItemView, AssessTestItemViewMath, } from './AssessTest'

/* AssessmentTesting

  <AssessTestTake
    userAssessment={this.props.userAssessment}
    routeParams={this.props.routeParams}
    search={this.props.search}
    setInTest={this.props.setInTest}
    activeItem={this.props.activeItem}
    selectAnswer={this.props.handleSubmitActivity}
    selectedAnswer={selectedAnswer}
    itemNumber={itemNumber}
    handleSubmitActivity={this.props.handleSubmitActivity}
    handleQuickNav={this.props.handleQuickNav}
    timeRemaining={this.props.timeRemaining}
  />

  Group:
  <AssessTestTake
    userAssessment={this.props.groupUA}
    routeParams={this.props.routeParams}
    search={this.props.search}
    setInTest={this.props.setInTest}
    activeItem={this.props.activeItem}
    selectAnswer={this.props.handleSubmitActivity}
    selectedAnswer={''}
    itemNumber={itemNumber}
    handleSubmitActivity={this.props.handleSubmitActivity}
    handleQuickNav={this.props.handleQuickNav}
    timeRemaining={this.props.timeRemaining}
    isGroup={true}
  />

*/
class AssessTestTake extends Component {
  componentDidMount() {
    document.body.classList.add('sidebar-hidden')
    document.body.classList.remove('sidebar-mobile-show')
  }

  render() {
    const props = this.props
    let lastItemNumber = 1
    let completed = false
    if (props.userAssessment) {
      const subTestSetId = props.routeParams.subTestSetId
      lastItemNumber = props.userAssessment.destructuredSubtests[subTestSetId].items.length
      completed = props.userAssessment.destructuredSubtests[subTestSetId].complete
    }
    if (props.isGroup) {
      completed = true
    }
    let answersByItem = null
    let answersByItemAll = null
    if (props.groupUA && props.subtestId && props.activeItem && props.groupUA.answersByItem[props.subtestId][props.activeItem.itemId]!==undefined && props.groupUA.answersByItem[props.subtestId]!==undefined
    && props.groupUA.answersByItem !==undefined  
      )  {
      answersByItem = props.groupUA.answersByItem[props.subtestId][props.activeItem.itemId]
      answersByItemAll = props.groupUA.answersByItem[props.subtestId]
    }
    let comp = null
    let subtestName = props.subtestName.toLowerCase()
      comp = (
        <AssessTestItemView
          activeItem={props.activeItem}
          selectAnswer={props.selectAnswer}
          selectedAnswer={props.selectedAnswer}
          itemNumber={props.itemNumber}
          nextItemLinkTo={`?item=${parseInt(props.itemNumber) + 1}`}
          completed={completed}
          handleSubmit={props.handleSubmitActivity}
          lastItemNumber={lastItemNumber}
          handleQuickNav={props.handleQuickNav}
          isGroup={props.isGroup}
          assessmentId={props.assessmentId}
          selectedStudent={props.selectedStudent}
          answersByItem={answersByItem}
          user={props.user}
          userAssessment={props.userAssessment}
          groupUA={props.groupUA}
          subtestId={props.subtestId}
          selectedGroupUA={props.selectedGroupUA}
          search={props.search}
          handleSubmitSubtest={props.handleSubmitSubtest}
          navTo={props.navTo}
          items={props.items}
          answersByItemAll={answersByItemAll}
          subtestName={subtestName}
          toggleAnswerExpired={this.props.toggleAnswerExpired}
          answerSelectedExpired={this.props.answerSelectedExpired}
          licenseExpired={this.props.licenseExpired}
        />
      )
  
  
    return (
      <div className={`${subtestName}-test`}>{comp}</div>
    )
  }
}

export default AssessTestTake


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTestTake.js